




import { computed, defineComponent } from '@vue/composition-api';
import { bemx } from '@berlin-front/common/utils';

/**
 * ## セパレーター
 *
 * AppContainerの中でborderを引くだけのコンポーネント。
 * 薄さ（線の太さ）とAppContainerのパディングを無視してラインを引くかを指定できる。
 *
 */
export default defineComponent({
  name: 'AppSeparator',
  props: {
    /** 薄いセパレーター。
     * 指定すると0.5pxになる。
     * */
    thin: {
      type: Boolean,
      default: false,
    },

    /** 余白なし。
     * AppContainerのパディングを無視してラインを引く。
     * */
    zeroPadding: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const className = computed(() => bemx('AppSeparator', { thin: props.thin, zeroPadding: props.zeroPadding }));
    return {
      className,
    };
  },
});
